
export const getTranspose = (row, col) => {
    let base = -32;
    return base +  1.5*(row * 2  + col*6);
};
